// extracted by mini-css-extract-plugin
export default {"buttonsHandlerContainer":"PatientContentButtons_buttonsHandlerContainer__BFVPb"};